import React from 'react';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';
import Fab from '@material-ui/core/Fab';

import Rule from './Rule';
import { AddIcon } from '../../../../images/icons/WrapSvg';

class Rules extends React.Component {
    state = {
        rules: [],
        ids: []
    };

    static getDerivedStateFromProps(props, state) {
        const { rules, selectedField, selectedType } = props;
        if (rules !== state.rules || (state.selectedField !== selectedField && selectedField !== undefined) || (state.selectedType !== selectedType && selectedType !== undefined)) {
            state.rules = rules;
            state.selectedField = selectedField;
            state.selectedType = selectedType;
            state.ids = selectedField && selectedType
                        ?
                            rules.reduce((list, rule) => {
                                list = list.concat(
                                    rule[selectedType].reduce((r, i) => {
                                        if(i.parametros && i.parametros.campo && i.parametros.campo.codigo === selectedField) {
                                            r.push(rule.id);
                                        } 
                                        return r;
                                    }, [])
                                )
                                return list;
                            }, [])
                        : state.ids;
            return state;
        }
        return null;
    }


    render() {
        const { rules, ids } = this.state;
        return (
            <div className="flex_full_column padding_top_12 padding_borders_equals">
                <div className={"flex_auto_row barlow_semibold c_dark_grey_blue padding_left_36 padding_right_24 padding_top_12 margin_bottom_24 "}>
                    <span className="flex_full_row">
                        <FormattedMessage id="checks_add_rule_title" />
                    </span>
                    <Fab
                        onClick={this.props.onAddRule}
                        color="primary"
                        classes={{ root: 'xhef_button_add_command' }}
                        className="button_float_40"
                    >
                        <AddIcon />
                    </Fab>
                </div>
                <div className="padding_left_36 padding_right_24 padding_top_12">
                    {rules &&
                        rules
                            .filter((f) => ids.indexOf(f.id) >= 0)
                            .map((r) => (
                                <Rule 
                                    {...this.props}
                                    key={randomstring()}
                                    rule={r} 
                                    />
                            ))}
                    {rules &&
                        rules
                            .filter((f) => ids.indexOf(f.id) < 0)
                            .map((r) => (
                                <Rule 
                                    {...this.props}
                                    key={randomstring()}
                                    rule={r} 
                                    />
                            ))}
                </div>
            </div>
        );
    }
}

export default Rules;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Rules.js